import FileSaver from 'file-saver';

export default {
  methods: {
    download(filename, downloadLink) {
      FileSaver.saveAs(downloadLink, filename);
    },
    downloadWithExtension(item, downloadLink) {
      let filename = item.name;
      if (item.type) {
        filename = `${item.name}.${item.type}`;
      }
      FileSaver.saveAs(downloadLink, filename);
    },
  },
};
